export const GET_THREADS = 'GET_THREADS'
export const CREATE_THREAD = 'CREATE_THREAD'
export const GET_THREAD_MESSAGES = 'GET_THREAD_MESSAGES'
export const READ_THREAD_MESSAGES = 'READ_THREAD_MESSAGES'
export const SEND_THREAD_MESSAGE = 'SEND_THREAD_MESSAGE'
